export function updateText(oldValue, newValue, object) {
  object.nodeValue = "".concat(newValue) || '';
}